import styled from "styled-components";
import { colors } from "@/theme";

export const AdminNavBarContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: center;
  column-gap: 10px;
`;

export const NavLinkContainer = styled.div`
  & a {
    color: ${colors.black};
    font-family: "PF DIN Text Pro";
    font-size: 16px;
    font-style: normal;
    text-decoration: none;
  }
`;
